import React from 'react';

import { cn } from '@/src/util/ui';

import { FILE_ICONS } from './FIleIcons';
import whatsappIcon from './svg/whatsapp';
import { SVG_ICONS } from './SVGIcons';

export const ICONS = {
  add: 'add',
  info: 'info',
  tag: 'local_offer',
  delete: 'delete_outline',
  file: 'description',
  edit: 'edit',
  attach: 'attach_file',
  attach_email: 'attach_email',
  close: 'close',
  cancel: 'cancel',
  do_not_disturb: 'do_not_disturb',
  error_outline: 'error_outline',
  error: 'error',
  link: 'link',
  check: 'done',
  check_circle: 'check_circle',
  message: 'chat',
  email: 'mail',
  arrow_downward: 'arrow_downward',
  arrow_upward: 'arrow_upward',
  arrow_right: 'chevron_right',
  arrow_left: 'chevron_left',
  arrow_back: 'arrow_back', // arrow w/ tail
  dropdown: 'arrow_drop_down', // arrow dropdown usually for dropdown fields
  dropdown_up: 'arrow_drop_up',
  dropdown_left: 'arrow_left',
  dropdown_right: 'arrow_right',
  calendar: 'calendar_today',
  search: 'search',
  inbox: 'inbox',
  trash: 'delete',
  archive: 'archive',
  duplicate: 'content_copy',
  create_task: 'add_task',
  ellipsis_horizontal: 'more_horiz',
  ellipsis_vertical: 'more_vert',
  refresh: 'refresh',
  restore: 'restore',
  warning: 'priority_high',
  warning_amber: 'warning_amber',
  filter_list: 'filter_list',
  send: 'send',
  notifications: 'notifications',
  flag: 'flag',
  full_screen: 'fullscreen',
  minimize_screen: 'fullscreen_exit',
  open_in_full: 'open_in_full',
  close_fullscreen: 'close_fullscreen',
  palette: 'format_color_fill',
  list: 'list',
  calendar_month: 'date_range',
  chevron_left: 'chevron_left',
  chevron_right: 'chevron_right',
  insert_link: 'insert_link',
  visible: 'visibility',
  visible_off: 'visibility_off',
  building: 'apartment',
  lock_outline: 'lock',
  push_pin: 'push_pin',
  volume_up: 'volume_up',
  volume_off: 'volume_off',
  pdf: 'picture_as_pdf',
  whatsapp: whatsappIcon,
  ...FILE_ICONS,
  ...SVG_ICONS,
};

export const ICON_POSITIONS = {
  prefix: 'prefix',
  suffix: 'suffix',
};

export const ICON_TYPES = {
  outlined: 'material-icons-outlined',
  filled: 'material-icons',
  rounded: 'material-icons-round',
  sharp: 'material-icons-sharp',
  two_tone: 'material-icons-two-tone',
};

export const Icon = ({
  icon,
  contentPosition = ICON_POSITIONS.suffix,
  className = '',
  iconType = ICON_TYPES.filled,
  iconRef = null,
  children = null,
  ...otherProps
}) => {
  const renderIconContent = () => {
    if (React.isValidElement(icon)) return icon;
    if (typeof icon === 'function') {
      const Comp = icon;
      try {
        const iconProps = { ...otherProps };
        if (iconProps.className) delete iconProps.className;
        return <Comp {...iconProps} />;
      } catch (e) {
        // fall through and render nothing
        return null;
      }
    }

    // assume material icon string
    return icon;
  };

  // If the icon is a function or element (SVG/file), render inside a span so we don't apply material icon classes
  if (typeof icon === 'function' || React.isValidElement(icon)) {
    return (
      <span ref={iconRef} className={cn(className)} {...otherProps}>
        {contentPosition === ICON_POSITIONS.prefix && renderIconContent()}
        {children}
        {contentPosition === ICON_POSITIONS.suffix && renderIconContent()}
      </span>
    );
  }

  return (
    <i ref={iconRef} className={cn(iconType, className)} {...otherProps}>
      {contentPosition === ICON_POSITIONS.prefix && renderIconContent()}
      {children}
      {contentPosition === ICON_POSITIONS.suffix && renderIconContent()}
    </i>
  );
};

export default Icon;
